const makeKey = (userId: string) => `tablein_active_tenant_${userId}`;

export function storeActiveTenant(userId: string, tenantId: string) {
  localStorage.setItem(makeKey(userId), tenantId);
}

export function loadActiveTenant(userId: string): string | null {
  return localStorage.getItem(makeKey(userId));
}

export function clearActiveTenant(userId: string) {
  localStorage.removeItem(makeKey(userId));
}

